import AntAuth from './AntAuth';

export const SALES_PRODUCT_CATALOG_CACHE_NAME = 'ARItemStatus-SalesProductCatalogue';
export const SALES_PRODUCT_CATALOG_CACHE_SCHEMA_VERSION = 1;
export const SALES_PRODUCT_CATALOG_CACHE_SECONDS = 60 * 60;
export const SALES_PRODUCT_CATALOGUE_FIELDS = ['catalogue1', 'catalogue2', 'catalogue3'];
export const SALES_PRODUCT_CATALOG_SEARCH_FIELDS = [
    'item_name',
    'item_code',
    'item_short_code',
    'item_barcode',
    'variant_barcode',
    'variant_dimens'
];
export const SALES_PRODUCT_CATALOG_FIELDS = [
    'id',
    'item_name',
    'item_short_code',
    'avatar_full_path',
    'avatar_short_path',
    'net_unit_price',
    'gross_unit_price',
    'vat_tax_code',
    'vat_tax_pct',
    'vat_tax_amt',
    'discount_unit_price',
    'discount_unit_pct',
    'is_salable',
    'item_is_active',
    'item_type',
    'item_code',
    'combo_code',
    'variant_code',
    'variant_dimens',
    'item_barcode',
    'variant_barcode',
    'uom',
    ...SALES_PRODUCT_CATALOGUE_FIELDS
];

export function getSalesProductCatalogCacheKey() {
    return [
        `schema:${SALES_PRODUCT_CATALOG_CACHE_SCHEMA_VERSION}`,
        AntAuth.getSessionInfo('business_code') || '',
        AntAuth.getSessionInfo('user_code') || '',
        AntAuth.getSessionInfo('store_code') || '',
        AntAuth.getSessionToken() || ''
    ].join('|');
}

export function getCatalogueKey(value) {
    if (value === undefined || value === null || value === '') return '';
    if (typeof value !== 'object') return String(value);
    if (value.code !== undefined) return String(value.code);
    if (value.value !== undefined) return String(value.value);
    if (value.name !== undefined) return String(value.name);
    return '';
}

export function getRowCatalogueValues(row) {
    const values = [];
    const keys = new Set();
    SALES_PRODUCT_CATALOGUE_FIELDS.forEach((field) => {
        const sourceValues = row?.[field] instanceof Array ? row[field] : [row?.[field]];
        sourceValues.forEach((value) => {
            const key = getCatalogueKey(value);
            if (!key || keys.has(key)) return;
            keys.add(key);
            values.push(value);
        });
    });
    return values;
}

export function buildCatalogueIndex(rows) {
    const values = [];
    const byValue = new Map();
    (rows instanceof Array ? rows : []).forEach((row) => {
        getRowCatalogueValues(row).forEach((value) => {
            const key = getCatalogueKey(value);
            const bucket = byValue.get(key);
            if (bucket) bucket.push(row);
            else {
                byValue.set(key, [row]);
                values.push(value);
            }
        });
    });
    return { values, byValue };
}

export function filterRowsByCatalogue(rows, value) {
    const key = getCatalogueKey(value);
    if (!key) return rows instanceof Array ? rows : [];
    return (rows instanceof Array ? rows : []).filter((row) => getRowCatalogueValues(row).some((item) => getCatalogueKey(item) === key));
}

export default {
    cacheName: SALES_PRODUCT_CATALOG_CACHE_NAME,
    cacheSchemaVersion: SALES_PRODUCT_CATALOG_CACHE_SCHEMA_VERSION,
    cacheSeconds: SALES_PRODUCT_CATALOG_CACHE_SECONDS,
    fields: SALES_PRODUCT_CATALOG_FIELDS,
    catalogueFields: SALES_PRODUCT_CATALOGUE_FIELDS,
    searchFields: SALES_PRODUCT_CATALOG_SEARCH_FIELDS,
    getCacheKey: getSalesProductCatalogCacheKey,
    getRowCatalogueValues,
    buildCatalogueIndex,
    filterRowsByCatalogue
};
